export default "__VITE_ASSET__7702060c__"